<template>
  <b-row>
    <b-col cols="12" lg="12">
      <label
        for="excmcase_idDevice"
        class="form-control-label">{{$t('views.excmcase.form.idDevice')}}</label>
      <b-row>
        <b-col>
          <div :class="['form-group', isInvalid('idDevice') ? 'has-danger' : '']">
            <fg-input :error="violations.idDevice">
              <el-select
                id="excmcase_idDevice"
                :class="['select-default', isInvalid('idDevice') ? 'select-danger' : '']"
                :placeholder="$t('views.excmcase.form.idDeviceSearch') + ' (' + EXCMDevices.length + ')'"
                filterable
                remote
                reserve-keyword
                :disabled="idDevice"
                v-model="item.idDevice">
                <el-option v-for="option in EXCMDevices"
                           class="select-default"
                           :value="option['@id']"
                           :label="option.idDeviceModel.idDeviceBrand.brandTitle + ' ' + option.idDeviceModel.model + ' - ' + option.serialNumber"
                           :key="option['@id']">
                </el-option>
              </el-select>
            </fg-input>
          </div>
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="2">
      <label>{{$t("views.excmdevicestate.list.table.date")}}: </label>
      <VueCtkDateTimePicker no-header
                            :label="$t('views.excmdevicestate.list.table.date')"
                            v-model.lazy="item.readDate"
                            format="YYYY-MM-DD HH:mm"
                            :onlyDate="false"
                            :right="true"
                            formatted="YYYY-MM-DD HH:mm"
      >
      </VueCtkDateTimePicker>
    </b-col>
    <b-col cols="2">
      <label>{{$t("views.excmdevicestate.list.table.totalCounter")}}: </label>
      <input id="value" type="number" class="form-control" v-model="item.counterPrint">
    </b-col>
    <b-col cols="2">
      <label>{{$t("views.excmdevicestate.list.table.monoCounter")}}: </label>
      <input id="value" type="number" class="form-control" v-model="item.counterMono">
    </b-col>
    <b-col cols="2">
      <label>{{$t("views.excmdevicestate.list.table.colorCounter")}}: </label>
      <input id="value" type="number" class="form-control" v-model="item.counterColor">
    </b-col>
    <b-col cols="2">
      <label>{{$t("views.excmdevicestate.list.table.copy")}}: </label>
      <input id="value" type="number" class="form-control" v-model="item.counterCopy">
    </b-col>
    <b-col cols="2">
      <label>{{$t("views.excmdevicestate.list.table.printout")}}: </label>
      <input id="value" type="number" class="form-control" v-model="item.counterPrint">
    </b-col>
    <b-col cols="2">
      <label>{{$t("views.excmdevicestate.list.table.a3")}}: </label>
      <input id="value" type="number" class="form-control" v-model="item.counterA3">
    </b-col>
    <b-col cols="2">
      <label>{{$t("views.excmdevicestate.list.table.a4")}}: </label>
      <input id="value" type="number" class="form-control" v-model="item.counterA4">
    </b-col>
    <b-col cols="2">
      <label>{{$t("views.excmdevicestate.list.table.monoA3")}}: </label>
      <input id="value" type="number" class="form-control" v-model="item.counterA3Mono">
    </b-col>
    <b-col cols="2">
      <label>{{$t("views.excmdevicestate.list.table.monoA4")}}: </label>
      <input id="value" type="number" class="form-control" v-model="item.counterA4Mono">
    </b-col>
    <b-col cols="2">
      <label>{{$t("views.excmdevicestate.list.table.colorA3")}}: </label>
      <input id="value" type="number" class="form-control" v-model="item.counterA3Color">
    </b-col>
    <b-col cols="2">
      <label>{{$t("views.excmdevicestate.list.table.colorA4")}}: </label>
      <input id="value" type="number" class="form-control" v-model="item.counterA4Color">
    </b-col>
    <b-col cols="2">
      <label>{{$t("views.excmdevicestate.list.table.bkToner")}}: </label>
      <input id="value" type="number" class="form-control" v-model="item.tonerLevelBk">
    </b-col>
    <b-col cols="2">
      <label>{{$t("views.excmdevicestate.list.table.cToner")}}: </label>
      <input id="value" type="number" class="form-control" v-model="item.tonerLevelC">
    </b-col>
    <b-col cols="2">
      <label>{{$t("views.excmdevicestate.list.table.mToner")}}: </label>
      <input id="value" type="number" class="form-control" v-model="item.tonerLevelM">
    </b-col>
    <b-col cols="2">
      <label>{{$t("views.excmdevicestate.list.table.yToner")}}: </label>
      <input id="value" type="number" class="form-control" v-model="item.tonerLevelY">
    </b-col>
    <b-col cols="2">
      <label>{{$t("views.excmdevicestate.list.table.message")}}: </label>
      <input id="value" type="text" class="form-control" v-model="item.maintenanceStatus">
    </b-col>
    <b-col cols="2">
      <label>{{$t("views.excmdevicestate.list.table.notes")}}: </label>
      <input id="value" type="text" class="form-control" v-model="item.notes">
    </b-col>
    <b-col cols="12 mt-2">
      <button
        type="submit"
        class="btn btn-success"
        @click="handleSubmit()"
      >{{$t('buttons.submit')}}</button>
    </b-col>
  </b-row>
</template>

<script>
import ApiService from '@/utils/ApiService'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    BaseSelectInput,
    VueCtkDateTimePicker
  },
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },
    handleUpdateField: {
      type: Function,
      required: true
    },
    values: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      default: () => {}
    },
    initialValues: {
      type: Object,
      default: () => {}
    },
    idDevice: {
      type: String,
      default: null
    }
  },

  created () {
    this.getDevices()
  },
  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },
  data () {
    return {
      EXCMDevices: [],
      emptyOption: {
        value: null,
        label: this.$t('views.excmdevicestate.form.empty')
      }
    }
  },

  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    async getDevices () {
      this.EXCMAgreementDevices = []
      let params = {
        'state': 1,
        'pagination': false
      }
      const response = await new ApiService(`e_x_c_m_devices`, params).getResults()
      this.EXCMDevices = response.items
    }
  }
}
</script>
